import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const initialState = {
    orderFilter: [
        //Example structure
        // {
        //     driverId: 0,
        //     parcelStatus: [],
        //     parcelWeight: [],
        // }
    ]
}

export const slice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        changeParcelStatusFilter: (state, action) => {
            if(!action.payload.driverId) return
            let driverIndex = _.findIndex(state.orderFilter, {'driverId': action.payload.driverId})
            if(driverIndex == -1){
                state.orderFilter.push({
                    driverId: action.payload.driverId,
                    parcelStatus: [],
                    parcelWeight: []
                })
                driverIndex = state.orderFilter.length - 1
            }

            if(action.payload.parcelStatus && action.payload.parcelStatus !== null){
                let parcelStatusIndex = _.indexOf(state.orderFilter[driverIndex].parcelStatus, action.payload.parcelStatus)
                if(parcelStatusIndex == -1){
                    //If current filter not active, add it
                    state.orderFilter[driverIndex].parcelStatus.push(action.payload.parcelStatus)
                } else {
                    //If current filter is active, remove it
                    _.pullAt(state.orderFilter[driverIndex].parcelStatus, [parcelStatusIndex])
                }
            }

            if(action.payload.parcelWeight && action.payload.parcelWeight !== null){
                let parcelWeightIndex = _.findIndex(state.orderFilter[driverIndex].parcelWeight, ['name', action.payload.parcelWeight.name])
                if(parcelWeightIndex == -1){
                    //If current filter not active, add it
                    state.orderFilter[driverIndex].parcelWeight.push(action.payload.parcelWeight)
                } else {
                    //If current filter is active, remove it
                    _.pullAt(state.orderFilter[driverIndex].parcelWeight, [parcelWeightIndex])
                }
            }
        },
        resetOrderFilter: (state, action) => {
            if(!action.payload.driverId) {
                state.orderFilter = initialState.orderFilter
                return
            }
            let filterIndex = getFilterIndex(action.payload.driverId, state.orderFilter)
            if(filterIndex !== -1){
                state.orderFilter[filterIndex] = {
                    driverId: action.payload.driverId,
                    parcelStatus: [],
                    parcelWeight: []
                }
            }
        }
    }
})

export const {
    changeParcelStatusFilter,
    resetOrderFilter
} = slice.actions;

export const getOrderFilter = state => state.filter.orderFilter

function getFilterIndex(driverId, filters){
    return _.findIndex(filters, ['driverId', driverId])
}

export default slice.reducer;